import { useSeo } from "@/hooks/useSeo";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  useSeo({
    title: "Privacy Policy",
    description: "Privacy Policy for Meridian Vanguard Solutions, LLC.",
    path: "/privacy",
    breadcrumb: [{ name: "Home", path: "/" }, { name: "Privacy Policy", path: "/privacy" }],
  });

  return (
    <section className="bg-white pt-40 pb-24 md:pb-32">
      <div className="w-full max-w-3xl mx-auto px-6 md:px-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-accent2 hover:text-navy transition-colors">
          <ArrowLeft size={16} /> Back to Home
        </Link>
        <h1 className="mt-6 font-heading text-4xl md:text-5xl font-extrabold text-navy tracking-tight">
          Privacy Policy
        </h1>
        <p className="mt-4 text-sm text-steel">Last updated: {new Date().getFullYear()}</p>

        <div className="mt-10 space-y-8 text-steel leading-relaxed text-[15px]">
          <div>
            <h2 className="font-heading text-xl font-semibold text-navy">Overview</h2>
            <p className="mt-3">
              Meridian Vanguard Solutions, LLC ("we," "us," or "our") respects your privacy. This
              policy explains how we collect, use, and safeguard information submitted through our
              website contact and vendor partnership forms.
            </p>
          </div>
          <div>
            <h2 className="font-heading text-xl font-semibold text-navy">Information We Collect</h2>
            <p className="mt-3">
              We collect only the information you voluntarily provide, such as your name, email
              address, phone number, company, and message content. We do not sell or rent your
              information to third parties.
            </p>
          </div>
          <div>
            <h2 className="font-heading text-xl font-semibold text-navy">How We Use Information</h2>
            <p className="mt-3">
              Submitted information is used solely to respond to inquiries, evaluate vendor
              partnership opportunities, and communicate about procurement matters relevant to your
              request.
            </p>
          </div>
          <div>
            <h2 className="font-heading text-xl font-semibold text-navy">Data Security</h2>
            <p className="mt-3">
              We apply reasonable administrative and technical measures to protect the information
              you share with us. No method of transmission over the internet is fully secure, and we
              cannot guarantee absolute security.
            </p>
          </div>
          <div>
            <h2 className="font-heading text-xl font-semibold text-navy">Contact</h2>
            <p className="mt-3">
              For questions about this policy, contact us at{" "}
              <a href="mailto:info@meridianvanguardsolutions.com" className="text-accent2 hover:underline">
                info@meridianvanguardsolutions.com
              </a>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
